const actionTypes = {
  GET_PRODUCT_GROUP_START: "GET_PRODUCT_GROUP_START",
  GET_PRODUCT_GROUP_SUCCESS: "GET_PRODUCT_GROUP_SUCCESS",
  GET_PRODUCT_GROUP_FAILED: "GET_PRODUCT_GROUP_FAILED",
  GET_PRODUCT_CATEGORY_START: "GET_PRODUCT_CATEGORY_START",
  GET_PRODUCT_CATEGORY_SUCCESS: "GET_PRODUCT_CATEGORY_SUCCESS",
  GET_PRODUCT_CATEGORY_FAILED: "GET_PRODUCT_CATEGORY_FAILED",
  GET_BRAND_START: "GET_BRAND_START",
  GET_BRAND_SUCCESS: "GET_BRAND_SUCCESS",
  GET_BRAND_FAILED: "GET_BRAND_FAILED",
  GET_SUPPLIER_START: "GET_SUPPLIER_START",
  GET_SUPPLIER_SUCCESS: "GET_SUPPLIER_SUCCESS",
  GET_SUPPLIER_FAILED: "GET_SUPPLIER_FAILED",
  GET_CUSTOMERS_START: "GET_CUSTOMERS_START",
  GET_CUSTOMERS_SUCCESS: "GET_CUSTOMERS_SUCCESS",
  GET_CUSTOMERS_FAILED: "GET_CUSTOMERS_FAILED",
  GET_CURRENCY_START: "GET_CURRENCY_START",
  GET_CURRENCY_SUCCESS: "GET_CURRENCY_SUCCESS",
  GET_CURRENCY_FAILED: "GET_CURRENCY_FAILED",
};

export default actionTypes;
